<template functional>
  <v-dialog :value="props.value"
            v-on="listeners"
            scrollable
            :lazy="props.lazy"
            v-bind="data.attrs"
            :max-width="props.maxWidth">
    <v-card class="nx-dialog">
      <v-card-title class="nx-dialog__title">
        <v-icon :color="props.iconColor" v-if="props.icon" class="mr-2">{{ props.icon }}</v-icon>
        {{ props.title }}
      </v-card-title>

      <v-card-text class="nx-dialog__content">
        <slot></slot>
      </v-card-text>

      <v-card-actions v-if="slots().actions">
        <v-spacer></v-spacer>
        <slot name="actions"></slot>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'nx-dialog',
  props: {
    title: String,
    value: Boolean,
    icon: String,
    iconColor: {
      type: String,
      default: 'black',
    },
    maxWidth: {
      type: String,
      default: '600px',
    },
    lazy: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="stylus">
.nx-dialog {
  padding: 4px 4px 0;

  &__content {
    padding-top: 0;
    padding-bottom: 0;
  }

  &__title {
    color: black;
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
  }
}
</style>
